<style scoped>
@import "../../assets/css/table-list.css";
.form-title {
  line-height: 40px;
  text-indent: 10px;
  background-color: #f3f3f3;
  margin-bottom: 10px;
}
.margin-right10 {
  margin-right: 10px;
}
.detail-group section {
  margin-bottom: 14px;
}
.detail-group section label {
  margin-right: 15px;
}
.detail-group section label,
.detail-group section span {
  display: inline-block;
}
.tx-user {
  width: 50px;
  max-height: 100px;
}
</style>
<style>
.ivu-form-item-content {
  line-height: 33px;
}
</style>
<template>
  <div>
    <h3 class="title">通知预警</h3>
    <div>
      <div class="margin-bottom-10 header-group">
        <label class="margin-right10">状态</label>
        <Select v-model="d_search_state" @on-change="search">
          <Option value="已处理">已处理</Option>
          <Option value="未处理">未处理</Option>
        </Select>
        <label class="margin-right10">乙方名称</label>
        <Input v-model="d_search_name" placeholder="请输入乙方名称" />
        <Button type="primary" @click="search">查询</Button>
      </div>
      <Table :columns="d_columns" :data="d_data" border @on-selection-change="get_select_data"></Table>
    </div>
    <div class="margin-top-20">
      <Page
        :total="d_total"
        show-sizer
        show-total
        @on-change="flip"
        @on-page-size-change="change_size"
        class="pull-right"
      ></Page>
      <div class="clear-both"></div>
    </div>
  </div>
</template>
<script>
import apiNotice from "@/api/notice.js";
export default {
  name: "noticeMain_page",
  data() {
    return {
      params: {},
      d_total: 0,
      d_page: 1,
      d_page_size: 10,
      d_search_state: "",
      d_search_name: "",
      d_columns: [
        {
          title: "编号",
          key: "ID",
          width: 160,
        },
        {
          title: "合同",
          key: "ContracName",
        },
        {
          title: "租户",
          key: "BPartyName",
        },
        {
          title: "联系方式",
          key: "Phone",
        },
        {
          title: "预警原因",
          key: "Reason",
        },
        {
          title: "状态",
          key: "State",
        },
        {
          title: "通知日期",
          key: "Day",
        },
        {
          title: "操作",
          key: "do",
          width: 100,
          render: (h, params) => {
            let btns = [];
            params.row.State === "未处理" &&
              btns.push(
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        this.to_handle(params.row.ID, "已处理");
                      },
                    },
                  },
                  "处理"
                )
              );
            params.row.State === "已处理" &&
              btns.push(
                h(
                  "Button",
                  {
                    props: { type: "error", size: "small" },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "<p>您确认要删除该条通知吗？</p>",
                          onOk: () => {
                            this.to_delete(params.row.ID);
                          },
                        });
                      },
                    },
                  },
                  "删除"
                )
              );
            return h(
              "div",
              {
                style: {
                  paddingTop: "5px",
                },
              },
              btns
            );
          },
        },
      ],
      d_data: [],
      d_del_data: "",
    };
  },
  methods: {
    flip(page) {
      //翻页条件，每页多少条，多少页
      this.params.PageIndex = page;
      this.params.PageSize = this.d_page_size;
      this.pull_data();
    },
    change_size(size) {
      //改变limit 每页显示多少条
      this.params.PageSize = size;
      this.pull_data();
    },
    search() {
      this.params.PageIndex = 1;
      this.pull_data();
    },
    pull_data() {
      let _this = this;
      this.params.CondList = [];
      if (this.d_search_state) {
        this.params.CondList.push({
          Key: "n.State",
          Operator: "=",
          Value: this.d_search_state,
        });
      }
      if (this.d_search_name) {
        this.params.CondList.push({
          Key: "n.BPartyName",
          Operator: "like",
          Value: this.d_search_name,
        });
      }
      apiNotice.getList.post(this.params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          let rowsList = requestResult.RowsList;
          _this.d_data = rowsList;
          _this.d_total = requestResult.Total;
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    get_select_data(row) {
      //批量关闭或者执行通知
      let delData = "";
      for (let i = 0; i < row.length; i++) {
        delData += row[i].ID + ",";
      }
      delData =
        delData.substring(delData.length - 1) == ","
          ? delData.substring(0, delData.length - 1)
          : delData; // 去掉末尾逗号
      this.d_del_data = delData;
    },
    to_handle(_id, _state) {
      apiNotice.setState(_id, _state).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          this.$Message.success("状态修改成功");
          this.pull_data();
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    to_delete(_id) {
      apiNotice.del(_id).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          this.$Message.success("删除成功");
          this.pull_data();
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
  },
  created() {
    this.params = JSON.parse(JSON.stringify(apiNotice.getList.data));
    this.pull_data();
  },
  mounted() {},
};
</script>
